import { Component, Input, Output, EventEmitter, Inject } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { Institution } from '@nano/common/finance';
import { PartyBeneficiary } from '@nano/common/party-beneficiaries';
import { L10N_LOCALE, L10nLocale } from 'angular-l10n';

@Component({
  selector: 'app-beneficiary-account-number-input',
  templateUrl: './beneficiary-account-number-input.component.html',
  standalone: false
})
export class BeneficiaryAccountNumberInputComponent {
  @Input() beneficiaryAccountNumberControl: AbstractControl;
  @Input() selectedBeneficiary: PartyBeneficiary;
  @Input() institution: Institution;
  @Input() institutionValidating: boolean;
  @Input() beneficiaryAccountNumberMinLength: number;
  @Input() beneficiaryAccountNumberMaxLength: number;

  @Output() validating = new EventEmitter<boolean>();
  @Output() institutionChange = new EventEmitter<Institution>();
  @Output() userMustProvideInstitution = new EventEmitter<boolean>();

  constructor(@Inject(L10N_LOCALE) public locale: L10nLocale) {}

  onInstitutionValidating(event: boolean): void {
    this.validating.emit(event);
  }

  onInstitution(event: Institution): void {
    this.institutionChange.emit(event);
  }

  onUserMustProvideInstitution(event: boolean): void {
    this.userMustProvideInstitution.emit(event);
  }
}
